import { Icon } from './icon';

interface StepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  ariaLabel?: string;
}

export function Stepper({
  value,
  onChange,
  min = 1,
  max = 10,
  ariaLabel = 'Quantity',
}: StepperProps) {
  return (
    <div className="wb-stepper" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label="Decrease"
      >
        <Icon name="minus" size={18} />
      </button>
      <span className="wb-stepper-val" aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label="Increase"
      >
        <Icon name="plus" size={18} />
      </button>
    </div>
  );
}
